module.exports = __webpack_public_path__ + "static/img/titen.b067fc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/entry/img/titen.png
// module id = FrK1
// module chunks = 1